import React from "react";
import {ScreenComponent} from "../../app/components/screen/ScreenComponent";
import {GradientHeaderComponent} from "../../app/components/gradientheader/GradientHeaderComponent";
import {Paths} from "../../app/components/sidebar/Paths";
import {H3SectionComponent} from "../../app/components/section/SectionComponent";

export default function ITRecruitersScreen() {
    return (<ScreenComponent>
        <Header/>
        <Empathy/>
        <Questions/>
        <HowToContact/>
        <Prepare/>
        <HelpNotHurt/>
    </ScreenComponent>)
}

function Header() {
    return (
        <GradientHeaderComponent title={Paths.interviewTips.nested.recruiters.name}/>
    )
}

function Empathy() {
    return (
        <H3SectionComponent header="Have some empathy." removeTopPadding={true}>
            <p>Look, finding a job is an incredibly stressful time in your life. For most of us, we are looking for a
                new job because we dislike our current ones for one reason or another, or maybe it's for a big move.
                Just stress on stress on stress. And I get it, right? They're recruiters - this is their <i>job</i> -
                they should be willing to get on the phone with you at all hours of the day because this is what they
                are getting paid to do! Look, I'm not gonna sit here and say you gotta go the extra mile for them. I'm
                not sending gift cards, or thank you notes - I'm not singing their praises back to them. But have some
                understanding for another human being who has 100s of you trying to get in touch with them on the
                regular - while they are also figuring out how people should best fill out paperwork, apply for
                citizenship, look for new candidates, etc. Especially nowadays, when it feels like there are 1000s of
                applicants for a single job. You don't have to be a suck-up, but try to understand when they don't
                respond to you within a few minutes.</p>
        </H3SectionComponent>
    )
}

function Questions() {
    return (
        <H3SectionComponent header="Ask questions as early as possible.">
            <p>Not only could this look good as it shows you are putting in the work, and not leaving it to the last
                second, but it also gives them time to respond to you.</p>
        </H3SectionComponent>
    )
}

function HowToContact() {
    return (
        <H3SectionComponent header="Figure out the best way to get in touch with them.">
            <p>One of the biggest mistakes I see people make is that they assume you can only communicate by email, or
                maybe some tool. Not everyone is built the same. Straight up ask them, "What is the best way I can get
                in touch with you?" I've had some recruiters prefer texting, some comments on a Google Doc, some email,
                and some others in between. Help <i>them</i> help <i>you</i>. Make it as easy for them to respond, and
                they will probably do so.</p>
        </H3SectionComponent>
    )
}

function Prepare() {
    return (
        <H3SectionComponent header="Prepare for the meetings you will have with them during the interview process.">
            <p>It seems kind of silly that you have to prepare even just to meet with recruiters, when you are already
                killing yourself to prepare for the actual interview, but it's quite critical, in my opinion. I'm not
                saying you have to spend hours preparing for this interview, but do you know the best time you are
                guaranteed an answer to your questions? That's right, face-to-face. If you are meeting right before the
                phone-screen, make sure you have looked into what the phone-screen is for that company and come with any
                questions you have about it. Moving to the on-site? Here's only a billion questions I have about that.
                Team Matching - boom, here's some concerns I have there, too. Write questions down if you need to. These
                things can be nerve-wracking, or happen very quickly, make sure you are organized to get through them
                all.</p>
        </H3SectionComponent>
    )
}

function HelpNotHurt() {
    return (
        <H3SectionComponent header="Remember, they are here to help you, not hurt you.">
            <p>It may be quite obvious, but typically they get paid if you get the job. Don't be afraid to ask questions
                - even if you think they are silly. They <i>want</i> you getting the job. They will answer as much as
                they are legally allowed to. Don't be afraid to use them as a resource, but also, make sure you don't
                inundate them either. It's best to ask 10 questions at once, rather than 1 question every other day.
                Context switching is not fun for them either.</p>
        </H3SectionComponent>
    )
}
